import { useMutation } from '@tanstack/react-query';
import { diagnosticService } from '../services';
import type { DiagnosticExportFormat } from '../types';

export function useExportDiagnostic() {
  const mutation = useMutation({
    mutationFn: (format: DiagnosticExportFormat) => diagnosticService.exportData(format),
    onSuccess: (blob, format) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `diagnostic-export-${new Date().toISOString().slice(0, 10)}.${format}`;
      a.click();
      URL.revokeObjectURL(url);
    },
  });

  return {
    exportData: mutation.mutate,
    isExporting: mutation.isPending,
  };
}
